import { createContext } from "react";

const DF_LO0009Context = createContext();

export { DF_LO0009Context };
